import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginHighlightLeftImageInfo } from './PluginHighlightLeftImageInfo';
import { PluginHighlightLeftImageInfoContent } from './PluginHighlightLeftImageInfoContent';
import { PluginHighlightLeftImageInfoFigure } from './PluginHighlightLeftImageInfoFigure';

type Props = {
  index: number;
  data: PluginHighlightLeftImageInfo;
  updateData: (element: IElement, index: number) => void;
};

export const PluginHighlightLeftImageInfoFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginHighlightLeftImageInfo>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-highlight-left-image-info">
          <div className="showcase">
            <PluginHighlightLeftImageInfoContent data={data} update={update} />
            <PluginHighlightLeftImageInfoFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
